import styled, { css } from 'styled-components'

import AppBarComponent from '@mui/material/AppBar'
import BoxComponent from '@mui/material/Box'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import CallIcon from '@mui/icons-material/Call'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import { Button } from '../Button'
import { TypographyComponent } from '../Typography'

export interface ITabButtonprops {
  active?: boolean
}

export const Wrapper = styled(AppBarComponent)(
  ({ theme }) => css`
    && {
      position: relative;
      background-color: ${theme.colors.base.white};
      display: flex;
      width: 100vw;
      height: 8.2rem;
      padding: 0 ${theme.layout.padding.big};
      margin-bottom: ${theme.layout.margin.big};
      box-shadow: 0px 4px 4px rgba(8, 51, 101, 0.25);
      @media (max-width: ${theme.screen.medium}) {
        height: 5rem;
      }
      @media print {
        display: none;
      }
    }
  `
)

export const PerfilContent = styled(BoxComponent)(
  () => css`
    && {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: space-between;
    }
  `
)

export const Logo = styled.div(
  ({ theme }) => css`
    && {
      img {
        width: 10rem;
        height: 5rem;

        @media (max-width: ${theme.screen.small}) {
          width: 6rem;
          height: 3rem;
        }
      }
    }
  `
)

export const Favicon = styled.div(
  ({ theme }) => css`
    && {
      img {
        width: 6rem;
        height: 6rem;

        @media (max-width: ${theme.screen.small}) {
          width: 4rem;
          height: 4rem;
        }
      }
    }
  `
)

export const ButtonContact = styled(Button)(
  ({ theme }) => css`
    && {
      @media (max-width: ${theme.screen.small}) {
        span {
          margin: 0px;
        }
      }
    }
  `
)

export const ButtonLabel = styled('span')(
  ({ theme }) => css`
    && {
      @media (max-width: ${theme.screen.small}) {
        display: none;
      }
    }
  `
)
export const ContainerContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: ${theme.layout.gap.small};
    width: 100%;
  `
)

export const ModalBox = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.small};
    justify-content: space-between;
    width: 100%;
  `
)

export const BoxContact = styled.div(
  ({ theme }) => css`
    && {
      display: flex;
      align-items: flex-start;
      gap: ${theme.layout.gap.medium};
      cursor: pointer;
    }
  `
)

export const WhatsApp = styled(WhatsAppIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const Email = styled(AlternateEmailIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const Copy = styled(ContentCopyIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      color: ${theme.colors.primary.main};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};

      @media (max-width: ${theme.screen.small}) {
        font-size: ${theme.layout.iconSize.small};
        width: ${theme.layout.iconSize.small};
        height: ${theme.layout.iconSize.small};
      }
    }
  `
)

export const CopyDescription = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h4};
      color: ${theme.colors.primary.main};
      text-transform: uppercase;
      text-align: start;

      @media (max-width: ${theme.screen.medium}) {
        display: none;
      }
    }
  `
)

export const Phone = styled(CallIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const DescriptionModal = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h4};
      font-weight: 300;
      text-align: start;

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h2};
      }
    }
  `
)

export const ModalBoxButtons = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: ${theme.layout.gap.medium};
    margin-top: ${theme.layout.margin.base * 6}rem;
  `
)

export const CopyButton = styled(Button)(
  ({ theme }) => css`
    background: none;
    display: flex;
    gap: ${theme.layout.gap.medium};
  `
)

export const SocialIconsContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
  `
)

export const BackgroundIcon = styled.a(
  ({ theme }) => css`
    && {
      background-color: ${theme.colors.base.white};
      padding: ${theme.layout.padding.small};
      border-radius: 100%;
      display: flex;
      svg {
        color: ${theme.colors.primary.main};
        width: ${theme.layout.iconSize.big};
        height: ${theme.layout.iconSize.big};
      }
    }
  `
)
